<template>
  <nav
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
    id="sidebar"
  >
    <div class="scrollbar-inner  ">
      <!-- Nav Icon -->
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <div class="sidenav-header align-items-center">
        <router-link to="/dashboardoption" class="navbar-brand">
          <img @error="handleImageError" @load="$event.target.dataset.fallbackTried = ''" v-bind:class="{'cline-logo': tenantName == 'Cline'}"  v-bind:src="'https://bidside-logos.s3.amazonaws.com/' + tenantName +'.png'"  class="navbar-brand-img" />
        </router-link>
      </div>
      <div class="navbar-inner">
        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <!-- Nav items -->
          <ul class="navbar-nav" v-if="isTradeRecap">
            <li class="nav-item">
              <!-- <a class="nav-link" href="/dashboard">
                <i class="fa fa-desktop" aria-hidden="true"></i>
                <span class="nav-link-text">Dashboard</span>
              </a>-->
              <router-link to="/traderecap/dashboard" class="nav-link">
                <i class="fa fa-desktop" aria-hidden="true"></i>
                <span class="nav-link-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="collapse"
                aria-expanded="false"
                href="#data"
              >
                <i class="fa fa-file" aria-hidden="true"></i>
                <span
                  data-toggle="collapse"
                  aria-expanded="false"
                  class="dropdown-toggle"
                >Data Aggregator</span>
              </a>
              <ul class="collapse" id="data">
                <li>
                  <router-link to="/traderecap/importdata" class="nav-link">
                    <span class="nav-link-text">Import Data</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/traderecap/viewdata" class="nav-link">
                    <span class="nav-link-text">View Imported Data</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/traderecap/editdata" class="nav-link">
                    <span class="nav-link-text">Manage CUSIP</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="collapse"
                aria-expanded="false"
                href="#admin"
              >
                <i class="fa fa-cog" aria-hidden="true"></i>
                <span
                  data-toggle="collapse"
                  aria-expanded="false"
                  class="dropdown-toggle"
                >Site Administration</span>
              </a>
              <ul class="collapse" id="admin">
                <li  v-if="isAdmin ||  isSuperAdmin">
                  <router-link to="/traderecap/users" class="nav-link">
                    <span class="nav-link-text">Manage Users</span>
                  </router-link>
                </li>

                <li>
                  <router-link to="/traderecap/purposes" class="nav-link">
                    <span class="nav-link-text">Manage Purposes</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="navbar-nav" v-if="isBidSide">
            <li class="nav-item" v-if="isAdmin">
              <router-link to="/bidside/admin-dashboard" class="nav-link">
                <i class="fa fa-desktop" aria-hidden="true"></i>
                <span class="nav-link-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader && !isAdmin">
              <router-link to="/bidside/trader-dashboard" class="nav-link">
                <i class="fas fa-desktop"></i>
                <span class="nav-link-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link to="admin-setqtycapital" class="nav-link">
                <i class="fa fa-cog" aria-hidden="true"></i>
                <span class="nav-link-text">Set Qty & Capital</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin || isEditor | isTrader">
              <router-link to="admin-managecusips" class="nav-link">
                <i class="fa fa-ban" aria-hidden="true"></i>
                <span class="nav-link-text">Manage Cusip</span>
              </router-link>
            </li>
             <li class="nav-item" v-if="isAdmin ||  isSuperAdmin">
              <router-link to="admin-users" class="nav-link">
                <i class="fa fa-users" aria-hidden="true"></i>
                <span class="nav-link-text">Manage Users</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin || isSuperAdmin">
              <router-link to="admin-roles" class="nav-link">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span class="nav-link-text">Roles</span>
              </router-link>
            </li>
             <li class="nav-item" v-if="isTrader">
              <router-link to="/bidside/bid" class="nav-link">
                <i class="fas fa-gavel"></i>
                <span class="nav-link-text">Create Bid</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader">
              <router-link to="/bidside/mycusips" class="nav-link">
                <i class="fa fa-address-book"></i>
                <span class="nav-link-text">My Cusips</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin">
              <router-link to="/bidside/bidlist" class="nav-link">
                <i class="fas fa-chart-line"></i>
                <span class="nav-link-text">Outstanding Bids</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor">
              <router-link to="/bidside/executedbidlist" class="nav-link">
                <i class="fas fa-retweet"></i>
                <span class="nav-link-text">Executed Bids</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin">
              <router-link to="/bidside/history" class="nav-link">
                <i class="fas fa-history"></i>
                <span class="nav-link-text">History</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin">
              <router-link to="/bidside/notifications" class="nav-link">
                <i class="fas fa-bell"></i>
                <span class="nav-link-text">Notifications</span>
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav" v-if="isIms">
            <li class="nav-item">
              <router-link to="/ims/ims-dashboard" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fa fa-desktop" aria-hidden="true"></i>
                <span class="nav-link-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin ||  isSuperAdmin">
              <router-link to="/ims/admin-users" class="nav-link">
                <i class="fa fa-users" aria-hidden="true"></i>
                <span class="nav-link-text">Manage Users</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor" >
              <router-link to="/ims/ims-inventory" class="nav-link">
                <i class="fa fa-address-book" aria-hidden="true"></i>
                <span class="nav-link-text">Holdings</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isEditor" >
              <router-link to="/ims/ims-endofday" class="nav-link">
                <i class="fa fa-clock" aria-hidden="true"></i>
                <span class="nav-link-text">End of Day</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isSuperAdmin || isTrader || isAdmin || isEditor">
                  <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#admin"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Maintenance</span>
                  </a>
                  <ul class="collapse" id="admin">
                    <li v-if="isAdmin || isEditor">
                      <router-link to="/ims/ims-customers" class="nav-link">
                        <span class="nav-link-text">Customers</span>
                      </router-link>
                    </li>
                    <li v-if="isTrader || isAdmin || isEditor">
                      <router-link to="/ims/ims-cusips" class="nav-link">
                        <span class="nav-link-text">Cusips</span>
                      </router-link>
                    </li>
                    <li v-if="isAdmin || isEditor">
                      <router-link to="/ims/ims-settings" class="nav-link">
                        <span class="nav-link-text">Settings</span>
                      </router-link>
                    </li>
                    <li v-if="isSuperAdmin || isAdmin || isEditor">
                      <router-link to="/ims/ims-ecns" class="nav-link">
                        <span class="nav-link-text">ECNs</span>
                      </router-link>
                    </li>
                     <li v-if="isAdmin || isEditor">
                      <router-link to="/ims/ims-traders" class="nav-link">
                        <span class="nav-link-text">Traders</span>
                      </router-link>
                    </li>
                    <li v-if="isTrader || isAdmin || isEditor">
                      <router-link to="/ims/ims-tradingaccounts" class="nav-link">
                        <span class="nav-link-text">Trading Accounts</span>
                      </router-link>
                    </li>
                    <li v-if="isTrader || isAdmin || isEditor">
                      <router-link to="/ims/ims-file-logs?moduleName=ims" class="nav-link">
                        <span class="nav-link-text">File Logs</span>
                      </router-link>
                    </li>
                    <!-- <li v-if="isTrader || isAdmin || isEditor">
                      <router-link to="/ims/msrbreport" class="nav-link">
                        <span class="nav-link-text">Reports</span>
                      </router-link>
                    </li> -->
                    <li class="nav-item">
                        <a
                          class="nav-link dropdown-toggle"
                          data-toggle="collapse"
                          aria-expanded="false"
                          href="#Reports"
                        >
                          <span
                            data-toggle="collapse"
                            aria-expanded="false"
                            class="dropdown-toggle"
                          >Reports</span>
                         </a>
                            <ul class="collapse multi-child-nav" id="Reports">
                              <li>
                                <router-link to="/ims/msrbreport" class="nav-link" >
                                  <span class="nav-link-text">Revenue Detail Scan </span>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/ims/shortscan" class="nav-link">
                                  <span class="nav-link-text">Short scan</span>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/ims/pickfileforupload" class="nav-link">
                                  <span class="nav-link-text">Pick file for upload</span>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/ims/currentinventory" class="nav-link">
                                  <span class="nav-link-text">Current Inventory</span>
                                </router-link>
                              </li>
                              <!-- <li>
                                <router-link to="/ims/costmismatch" class="nav-link">
                                  <span class="nav-link-text">Cost Mismatch Export</span>
                                </router-link>
                              </li> -->
                              <!-- <li>
                                <router-link to="/ims/addtohib" class="nav-link">
                                  <span class="nav-link-text">Add to HIB</span>
                                </router-link>
                              </li> -->
                              
                            </ul>
                        </li> 
                        </ul>
                      </li>
            <li class="nav-item" v-if="isSuperAdmin || isTrader || isAdmin || isEditor">
                  <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#Offerings"
                  >
                    <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Offerings</span>
                  </a>
                  <ul class="collapse" id="Offerings">
                    <li v-if="isTrader || isEditor || isAdmin">
                      <router-link  to="/ims/ims-offering" class="nav-link">
                        <span class="nav-link-text">Offerings List</span>
                      </router-link>
                    </li>
                    <!-- <li v-if="!isTrader && ( isAdmin )">
                      <router-link  to="/ims/ims-offering/alloffering" class="nav-link">
                        <span class="nav-link-text">Offerings List</span>
                      </router-link>
                    </li> -->
                    <li v-if="isTrader || isAdmin || isEditor">
                      <router-link to="/ims/ims-offering-create" class="nav-link">
                        <span class="nav-link-text">Create Offerings</span>
                      </router-link>
                    </li>
                    <li v-if="isSuperAdmin || isTrader || isAdmin || isEditor">
                      <router-link to="/ims/ims-offering-recancel" class="nav-link">
                        <span class="nav-link-text">Cancelled Offerings</span>
                      </router-link>
                    </li>
                  </ul>
            </li>
            <li class="nav-item"  v-if="isTrader || isAdmin || isEditor">
              <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#arbs"
                  >
                    <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Arbs</span>
                  </a>
                  <ul class="collapse" id="arbs">
                    <li>
                      <router-link to="/ims/ims-arbs" class="nav-link">
                        <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                        <span class="nav-link-text">Arbs Offering</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/ims/ims-arbs-feed" class="nav-link">
                        <i class="fa fa-cloud" aria-hidden="true"></i>
                        <span class="nav-link-text">Arbs Feed Offering</span>
                      </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/ims/ecnlist" class="nav-link">
                          <i class="fa fa-broadcast-tower"></i>
                            <span class="nav-link-text">ECNs</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/ims/arbssettings-munis" class="nav-link">
                      <i class="fa fa-cog"></i>
                        <span class="nav-link-text">Settings (Munis)  </span>
                      </router-link>
                    </li>
                      <li class="nav-item">
                      <router-link to="/ims/arbssettings-corps" class="nav-link">
                      <i class="fa fa-cog"></i>
                        <span class="nav-link-text">Settings (Corps)  </span>
                      </router-link>
                    </li>
                  </ul>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor">
              <router-link to="/ims/ims-trades" class="nav-link">
                <i class="fa fa-chart-line" aria-hidden="true"></i>
                <span class="nav-link-text">Executed Trades</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor">
              <router-link to="/ims/ims-msrb" class="nav-link">
                <i class="fa fa-file" aria-hidden="true"></i>
                <span class="nav-link-text">MSRB</span>
              </router-link>
            </li>
          
              <li class="nav-item" v-if="isTrader || isAdmin || isEditor" >
              <router-link to="/ims/ims-rejected-trades" class="nav-link">
                <i class="fa fa-ban" aria-hidden="true"></i>
                <span class="nav-link-text">Rejected Offers</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor" >
              <router-link to="/ims/ims-deleted-offers" class="nav-link">
                <i class="fa fa-trash" aria-hidden="true"></i>
                <span class="nav-link-text">Deleted Offers</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin && isDev" >
              <router-link to="/ims/services" class="nav-link">
                <i class="fa fa-cog" aria-hidden="true"></i>
                <span class="nav-link-text">Services</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin && isDev" >
              <router-link to="/ims/schedulers" class="nav-link">
                <i class="fa fa-clock" aria-hidden="true"></i>
                <span class="nav-link-text">Schedulers</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin" >
              <router-link to="/ims/failurelogs" class="nav-link">
                <i class="fa fa-history" aria-hidden="true"></i>
                <span class="nav-link-text">Failure Logs</span>
              </router-link>
            </li> 
            
            <!-- <li class="nav-item" v-if="isAdmin || isEditor" >
              <router-link to="/ims/ims-profitandloss" class="nav-link">
                <i class="fa fa-balance-scale" aria-hidden="true"></i>
                <span class="nav-link-text">Profit and Loss </span>
              </router-link>
            </li> -->
            <li class="nav-item" v-if="(isTrader && traderId ) || isAdmin || isEditor || isSuperAdmin">
                  <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#pl"
                  >
                    <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Profit and Loss</span>
                  </a>
                  <ul class="collapse" id="pl"   >
                    <li >
                      <router-link  to="/ims/ims-profitandlossdashboard" class="nav-link">
                        <span class="nav-link-text">Dashboard</span>
                      </router-link>
                    </li>
                    <!-- <li v-if="isAdmin || isEditor || isSuperAdmin">
                      <router-link  to="/ims/ims-profitandlosstraders" class="nav-link">
                        <span class="nav-link-text">Traders</span>
                      </router-link>
                    </li> -->
                    <li v-if="isAdmin || isEditor || isSuperAdmin">
                      <router-link  to="/ims/ims-profitandlossdatesetting" class="nav-link">
                        <span class="nav-link-text">Date Setting</span>
                      </router-link>
                    </li>
                    <li v-if="isAdmin || isEditor || isSuperAdmin">
                      <router-link  to="/ims/ims-profitandlossrepcode" class="nav-link">
                        <span class="nav-link-text">Wealthscape</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link  to="/ims/ims-profitandloss" class="nav-link">
                        <span class="nav-link-text">Trades</span>
                      </router-link>
                    </li>
                    <li v-if="isAdmin || isEditor || isSuperAdmin">
                      <router-link  to="/ims/ims-profitandlosscommissions" class="nav-link">
                        <span class="nav-link-text">Commissions</span>
                      </router-link>
                    </li>
                    <!-- <li v-if="isAdmin || isEditor || isSuperAdmin">
                      <router-link  to="/ims/ims-cumulativebreakdown" class="nav-link">
                        <span class="nav-link-text">Cumulative Breakdown</span>
                      </router-link>
                    </li>
                    <li v-if="isAdmin  || isSuperAdmin">
                      <router-link  to="/ims/ims-traderbreakdown" class="nav-link">
                        <span class="nav-link-text">Trader Breakdown</span>
                      </router-link>
                    </li> -->
                    
                  </ul>
            </li>
            <!-- <li class="nav-item" v-if="isAdmin || isEditor" >
              <router-link to="/ims/ims-dailyuploads" class="nav-link">
                <i class="fa fa-upload" aria-hidden="true"></i>
                <span class="nav-link-text">Daily Uploads </span>
              </router-link>
            </li> -->
          </ul>
          <ul class="navbar-nav" v-if="isReport">
            <li class="nav-item">
              <router-link to="/reports/moneylinelist" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fas fa-dollar-sign" aria-hidden="true"></i>
                <span class="nav-link-text">Money Line</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/reports/accounts" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fa fa-user-circle" aria-hidden="true"></i>
                <span class="nav-link-text">Accounts</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/reports/tmcreport" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fas fa-upload" aria-hidden="true"></i>
                <span class="nav-link-text">Tmc Report</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/reports/hib" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fas fa-download" aria-hidden="true"></i>
                <span class="nav-link-text">HIB vs IDC</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isTrader || isAdmin || isEditor">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="collapse"
                :aria-expanded="isEodRoute ? 'true' : 'false'"
                href="#eod"
              >
                <i class="fas fa-users" aria-hidden="true"></i>
                <span
                  data-toggle="collapse"
                  :aria-expanded="isEodRoute ? 'true' : 'false'"
                  class="dropdown-toggle"
                >End Of Day</span>
              </a>
              <ul class="collapse" :class="{ show: isEodRoute }" id="eod">
                <li>
                  <router-link to="/reports/customers" class="nav-link">
                    <span class="nav-link-text">End Of Day</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/reports/EODlogs" class="nav-link">
                    <span class="nav-link-text">EOD Emails Log</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/reports/representative" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fas fa-suitcase" aria-hidden="true"></i>
                <span class="nav-link-text">Representative</span>
              </router-link>
            </li>
           
            
          </ul>
          <ul class="navbar-nav" v-if="isBidAccumulator">
            <li class="nav-item">
              <router-link to="/bidaccumulator/dashboard" v-if="isTrader || isOperator || isAdmin " class="nav-link">
                <i class="fas fa-desktop" aria-hidden="true"></i>
                <span class="nav-link-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/trader" v-if="isTrader" class="nav-link">
                <i class="fa fa-user-tie"></i>
                <span class="nav-link-text">Bid Wanted <span v-if="(isOperator && isTrader) || isAdmin" style="color:#FF9E47">(Trader)</span></span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/operator" v-if="isOperator" class="nav-link">
                <i class="fas fa-user-cog"></i>
                <span class="nav-link-text">Bid Wanted <span v-if="(isOperator && isTrader) || isAdmin" style="color:#FF9E47">(Operator)</span></span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/admin" v-if="isAdmin" class="nav-link">
                <i class="fa fa-user-shield"></i>
                <span class="nav-link-text">Bid Wanted <span v-if="isOperator || isTrader" style="color:#FF9E47">(Admin)</span></span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link to="/bidaccumulator/executedtrades" v-if="isTrader || isOperator || isAdmin" class="nav-link">
                <i class="fas fa-exchange-alt"></i>
                <span class="nav-link-text">Executed Trades</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/rejectedbidwanted" v-if="isTrader || isOperator || isAdmin" class="nav-link">
                <i class="fas fa-ban"></i>
                <span class="nav-link-text">Rejected Bid Wanted</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/deleted" v-if="isTrader || isOperator || isAdmin" class="nav-link">
                <i class="fas fa-trash"></i>
                <span class="nav-link-text">Deleted Bid Wanted</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/ecn" v-if="isTrader || isOperator || isAdmin" class="nav-link">
               <i class="fa fa-broadcast-tower"></i>
                <span class="nav-link-text">ECN</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/filelogs" v-if="isTrader || isOperator || isAdmin" class="nav-link">
               <i class="fas fa-calendar-day"></i>
                <span class="nav-link-text">Daily Bids</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/actionlogs" v-if="isTrader || isOperator || isAdmin" class="nav-link">
               <i class="fa fa-history"></i>
                <span class="nav-link-text">Action Logs</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link to="/bidaccumulator/traderlist" class="nav-link">
               <i class="fa fa-users"></i>
                <span class="nav-link-text">Traders</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="isDev || userId === 1">
              <router-link to="/bidaccumulator/failednotifications" v-if="isTrader || isOperator || isAdmin" class="nav-link">
               <i class="fa fa-exclamation-circle"></i>
                <span class="nav-link-text">Failed Notifications</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bidaccumulator/settings" v-if="isTrader || isOperator" class="nav-link">
               <i class="fa fa-cog"></i>
                <span class="nav-link-text">Settings</span>
              </router-link>
            </li>
            <li class="nav-item">
                <router-link to="/bidaccumulator/file-logs?moduleName=ba" class="nav-link">
                  <i class="fas fa-database"></i>
                    <span class="nav-link-text">File Logs</span>
                </router-link>
              </li>
          </ul>
          <ul class="navbar-nav" v-if="isTicketSystem">
            <li class="nav-item" v-if="!isGuest">
              <router-link to="/ticketsystem/importdata" class="nav-link">
                <i class="fas fa-upload" aria-hidden="true"></i>
                <span class="nav-link-text">Import Ticket</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isGuest">
              <router-link to="/ticketsystem/unprocessed"  class="nav-link">
                <i class="fas fa-history"></i>
                <span class="nav-link-text">Unprocessed Data</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/ticketsystem/processed"  class="nav-link">
                <i class="fas fa-check"></i>
                <span class="nav-link-text">Processed Data</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isGuest">
              <router-link to="/ticketsystem/processed-tickets"  class="nav-link">
                <i class="fas fa-folder-open"></i>
                <span class="nav-link-text">Processed Tickets</span>
              </router-link>
            </li>
             <li class="nav-item" v-if="!isGuest">
              <router-link to="/ticketsystem/trade-files"  class="nav-link">
                <i class="fas fa-file-invoice"></i>
                <span class="nav-link-text">Trade Files</span>
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav" v-if="isAutoBidder">
            <li class="nav-item" v-if="isCapitalRiskManager">
              <router-link to="/autobidder/bids" class="nav-link">
                <i class="fas fa-gavel" aria-hidden="true"></i>
                <span class="nav-link-text">Bid Wanteds</span>
              </router-link>
            </li>
             <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/ecns" class="nav-link">
                  <i class="fa fa-broadcast-tower"></i>
                    <span class="nav-link-text">ECNs</span>
                </router-link>
            </li>
            <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
              <router-link to="/autobidder/report" class="nav-link">
                <i class="fas fa-chart-bar"></i>
                <span class="nav-link-text">Report</span>
              </router-link>
            </li>  
            <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
              <router-link to="/autobidder/executedtrades" class="nav-link">
                <i class="fas fa-handshake"></i>
                <span class="nav-link-text">Executed Trades</span>
              </router-link>
            </li> 
            <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
              <router-link to="/autobidder/settings" class="nav-link">
               <i class="fa fa-cog"></i>
                <span class="nav-link-text">Settings</span>
              </router-link>
            </li>
           
            <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/supportdata" class="nav-link">
                  <i class="fa fa-book"></i>
                    <span class="nav-link-text">Support Data</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/donotbidlist" class="nav-link">
                  <i class="fa fa-ban"></i>
                    <span class="nav-link-text">Do Not Bid </span>
                </router-link>
              </li> 
            <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/filtersettings" class="nav-link">
                  <i class="fa fa-filter"></i>
                    <span class="nav-link-text">Filters & Search</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/biddingStrategy" class="nav-link">
                  <i class="fa fa-calculator"></i>
                    <span class="nav-link-text">Bidding Strategy</span>
                </router-link>
              </li>
              <li class="nav-item"  v-if="isAutoBidderPagesAllowed()">
                <router-link to="/autobidder/file-logs?moduleName=autobidder" class="nav-link">
                  <i class="fas fa-database"></i>
                    <span class="nav-link-text">File Logs</span>
                </router-link>
              </li>
              <li class="nav-item"  v-if="isAutoBidderPagesAllowed() && isAdmin">
                <router-link to="/autobidder/traders" class="nav-link">
                  <i class="fas fa-users"></i>
                    <span class="nav-link-text">Traders</span>
                </router-link>
              </li>  
              <li class="nav-item"  v-if="isAutoBidderPagesAllowed() && isAdmin">
                <router-link to="/autobidder/dailybids" class="nav-link">
                  <i class="fa fa-history"></i>
                    <span class="nav-link-text">Daily Bids History</span>
                </router-link>
              </li> 
              <li class="nav-item" v-if="( isSuperAdmin || isBranchRiskManager)">
              <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#Compliance"
                  >
                    <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Compliance</span>
                  </a>
                  <ul class="collapse" id="Compliance">
                    <li v-if="isBranchRiskManager || isSuperAdmin">
                      <router-link to="/autobidder/branchcapitalsettings" class="nav-link" >
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        <span class="nav-link-text">Capital Setting</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/autobidder/alert" class="nav-link">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <span class="nav-link-text">Alerts</span>
                      </router-link>
                    </li>
                    <!-- <li v-if="isBranchRiskManager">
                      <router-link to="/autobidder/approvalpending" class="nav-link">
                        <i class="fa fa-hourglass-start" aria-hidden="true"></i>
                        <span class="nav-link-text">Approval pending</span>
                      </router-link>
                    </li> -->
                    <li class="nav-item"  v-if="isBranchRiskManager">
                      <router-link to="/autobidder/compliancesettings?role=riskmanager" class="nav-link">
                        <i class="fa fa-cog"></i>
                          <span class="nav-link-text">Broker Dealer Settings</span>
                      </router-link>
                    </li> 
                  </ul>
              </li> 
              
              <li class="nav-item"  v-if="isTrader || isCapitalRiskManager ">
                <router-link to="/autobidder/tradercompliancesettings?role=trader" class="nav-link">
                  <i class="fa fa-cog"></i>
                    <span class="nav-link-text">Compliance Settings</span>
                </router-link>
              </li> 
          </ul>
          <ul class="navbar-nav" v-if="isBrockerDealerCompliance">
           
              <li class="nav-item">
              <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#Compliance"
                  >
                    <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Compliance</span>
                  </a>
                  <ul class="collapse" id="Compliance">
                    
                    <li>
                      <router-link to="/brockerdealer/brockerdealercapitalsettings" class="nav-link" >
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        <span class="nav-link-text">Capital Setting</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/brockerdealer/alert" class="nav-link">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <span class="nav-link-text">Alerts</span>
                      </router-link>
                    </li>
                  </ul>
              </li> 
              <li class="nav-item">
                <router-link to="/brockerdealer/manageusers" class="nav-link">
                  <i class="fa fa-users"></i>
                    <span class="nav-link-text">Users</span>
                </router-link>
              </li> 
           
          </ul>
          <ul class="navbar-nav" v-if="isOfferingFeed">
            <li class="nav-item">
              <router-link to="/offeringfeed/offerings" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fas fa-dollar-sign" aria-hidden="true"></i>
                <span class="nav-link-text">Offerings</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/offeringfeed/feedfilter" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fa fa-filter" aria-hidden="true"></i>
                <span class="nav-link-text">Filter</span>
              </router-link>
            </li>
             <li class="nav-item">
              <router-link to="/offeringfeed/hidden-offers" v-if="isTrader || isAdmin || isEditor" class="nav-link">
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                <span class="nav-link-text">Hidden Offers</span>
              </router-link>
            </li>
            <li class="nav-item" >
                <router-link to="/offeringfeed/file-logs?moduleName=offeringfeed" class="nav-link">
                  <i class="fas fa-database"></i>
                    <span class="nav-link-text">File Logs</span>
                </router-link>
              </li>
              <li class="nav-item" >
                <router-link to="/offeringfeed/settings" class="nav-link">
                  <i class="fas fa-cog"></i>
                    <span class="nav-link-text">Settings</span>
                </router-link>
              </li>
              <li class="nav-item">
              <a
                    class="nav-link dropdown-toggle"
                    data-toggle="collapse"
                    aria-expanded="false"
                    href="#Compliance"
                  >
                    <i class="fa fas fa-bell mt-0" aria-hidden="true"></i>
                    <span
                      data-toggle="collapse"
                      aria-expanded="false"
                      class="dropdown-toggle"
                    >Alerts</span>
                  </a>
                  <ul class="collapse" id="Compliance">
                    <li class="nav-item" >
                      <router-link to="/offeringfeed/feedalerts" class="nav-link">
                        <i class="fas fa-bell mt-0"></i>
                          <span class="nav-link-text">Notification History</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/offeringfeed/feedemails" class="nav-link">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                        <span class="nav-link-text">Customer Email Logs</span>
                      </router-link>
                    </li>
                  </ul>
              </li> 
              <!-- <li class="nav-item" >
                <router-link to="/offeringfeed/feedalerts" class="nav-link">
                  <i class="fas fa-bell mt-0"></i>
                    <span class="nav-link-text">Alerts</span>
                </router-link>
              </li> -->
            
            
          </ul>
          <ul class="navbar-nav" v-if="isDeMinimisTaxCalculator">
            <li class="nav-item" >
              <router-link to="/de-minimis/de-minimis-customer-report" class="nav-link">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span class="nav-link-text"> Customer Report</span>
              </router-link>
            </li>
             <li class="nav-item" >
              <router-link to="/de-minimis/de-minimis-tax-calculator" class="nav-link">
                <i class="fa fa-calculator" aria-hidden="true"></i>
                <span class="nav-link-text">De Minimis Calculator</span>
              </router-link>
            </li> 
            
             <li class="nav-item" >
              <router-link to="/de-minimis/de-minimis-file-log" class="nav-link">
                <i class="fa fa-file-alt" aria-hidden="true"></i>
                <span class="nav-link-text"> File Logs</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import $ from "jquery";
import Cookies from "js-cookie";
import authService from "@/authService";

export default {
  data() {
    return {
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      isOperator : false,
      isGuest : false,
      tenantName : null,
      window:window,
      isBidSide: window.location.pathname.includes('bidside'),
      isTradeRecap: window.location.pathname.includes('traderecap'),
      isIms: window.location.pathname.includes('ims'),
      isReport: window.location.pathname.includes('reports'),
      isClient: window.location.pathname.includes('client'),
      traderId : authService.getUser().traderId,
      userId : authService.getUser().id,
      isBidAccumulator : window.location.pathname.includes('bidaccumulator'),
      isTicketSystem : window.location.pathname.includes('ticketsystem'),
      isAutoBidder : window.location.pathname.includes('autobidder'),
      isBrockerDealerCompliance : window.location.pathname.includes('brockerdealer'),
      isOfferingFeed : window.location.pathname.includes('offeringfeed'),
      isDeMinimisTaxCalculator : window.location.pathname.includes('de-minimis'),
      defaultImage: 'https://bidside-logos.s3.amazonaws.com/Drl.png',
      isBranchRiskManager : false,
      isBrokerDealerRiskManager : false,
      isCapitalRiskManager : false

    };
  },
  computed: {
    isEodRoute () {
      // /reports/customers also covers the Scheduler tab (/reports/customers/scheduler)
      return ['/reports/customers', '/reports/EODlogs']
        .some(path => this.$route.path.startsWith(path))
    }
  },
  watch:{
    $route (){
      this.isBidSide = window.location.pathname.includes('bidside');
      this.isTradeRecap = window.location.pathname.includes('traderecap');
      this.isIms = window.location.pathname.includes('ims');
      this.isBidAccumulator = window.location.pathname.includes('bidaccumulator');
      this.isReport = window.location.pathname.includes('reports');
      this.isTicketSystem = window.location.pathname.includes('ticketsystem');
      this.isAutoBidder = window.location.pathname.includes('autobidder');
    }
} ,
  created() {
      this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          console.log("r",roleArray)

          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
          roleArray.includes('Operator')  ? this.isOperator = true : this.isOperator = false;
          roleArray.includes('Guest')  ? this.isGuest = true : this.isGuest = false;
          roleArray.includes("RiskManager") ? this.isBranchRiskManager = true : this.isBranchRiskManager = false;
          roleArray.includes("BrokerDealerRiskManager") ? this.isBrokerDealerRiskManager = true : this.isBrokerDealerRiskManager = false;
          roleArray.includes('CapitalRiskManager')   ? this.isCapitalRiskManager  = true : this.isCapitalRiskManager  = false;
      

        }
         //console.log("curret role",this.isAdmin,this.isTrader,this.isEditor,this.isSuperAdmin);
      });

  },
  methods:{
    handleImageError(event) {
      const img = event.target;
      const fallback = this.defaultImage;
      // Only fall back once: if there is no fallback, or the fallback itself failed,
      // setting src again re-fires @error and loops forever (thousands of image requests).
      if (!fallback || img.dataset.fallbackTried === fallback) {
        return;
      }
      img.dataset.fallbackTried = fallback;
      img.src = fallback;
    },
    isAutoBidderPagesAllowed(){
      if(this.isOperator || this.isTrader || this.isAdmin || this.isEditor || this.isCapitalRiskManager ){
        return true
      }else{
        return false
      }
    }
  },
  mounted(){
    function pinSidenav() {
        $(".sidenav-toggler").addClass("active");
        $(".sidenav-toggler").data("action", "sidenav-unpin");
        $("body")
            .removeClass("g-sidenav-hidden")
            .addClass("g-sidenav-show g-sidenav-pinned");
        $("body").append(
            '<div class="backdrop d-xl-none" data-action="sidenav-unpin" data-target=' +
            $("#sidenav-main").data("target") +
            " />"
        );

        // Store the sidenav state in a cookie session
        Cookies.set("sidenav-state", "pinned");
    }

    function unpinSidenav() {
        $(".sidenav-toggler").removeClass("active");
        $(".sidenav-toggler").data("action", "sidenav-pin");
        $("body")
            .removeClass("g-sidenav-pinned")
            .addClass("g-sidenav-hidden");
        $("body")
            .find(".backdrop")
            .remove();

        // Store the sidenav state in a cookie session
        Cookies.set("sidenav-state", "unpinned");
    }

    // Set sidenav state from cookie

    var $sidenavState = Cookies.get("sidenav-state") ?
        Cookies.get("sidenav-state") :
        "pinned";

    if ($(window).width() > 1200) {
        if ($sidenavState == "pinned") {
            pinSidenav();
        }

        if (Cookies.get("sidenav-state") == "unpinned") {
            unpinSidenav();
        }

        $(window).resize(function() {
            if (
                $("body").hasClass("g-sidenav-show") &&
                !$("body").hasClass("g-sidenav-pinned")
            ) {
                $("body")
                    .removeClass("g-sidenav-show")
                    .addClass("g-sidenav-hidden");
            }
        });
    }

    if ($(window).width() < 1200) {
        $("body")
            .removeClass("g-sidenav-hide")
            .addClass("g-sidenav-hidden");
        $("body").removeClass("g-sidenav-show");
        $(window).resize(function() {
            if (
                $("body").hasClass("g-sidenav-show") &&
                !$("body").hasClass("g-sidenav-pinned")
            ) {
                $("body")
                    .removeClass("g-sidenav-show")
                    .addClass("g-sidenav-hidden");
            }
        });
    }

    $("body").on("click", "[data-action]", function(e) {
        e.preventDefault();

        var $this = $(this);
        var action = $this.data("action");
        var target = $this.data("target");
        console.log(target);
        // Manage actions

        switch (action) {
            case "sidenav-pin":
                pinSidenav();
                break;

            case "sidenav-unpin":
                unpinSidenav();
                break;

            case "search-show":
                target = $this.data("target");
                $("body")
                    .removeClass("g-navbar-search-show")
                    .addClass("g-navbar-search-showing");

                setTimeout(function() {
                    $("body")
                        .removeClass("g-navbar-search-showing")
                        .addClass("g-navbar-search-show");
                }, 150);

                setTimeout(function() {
                    $("body").addClass("g-navbar-search-shown");
                }, 300);
                break;

            case "search-close":
                target = $this.data("target");
                $("body").removeClass("g-navbar-search-shown");

                setTimeout(function() {
                    $("body")
                        .removeClass("g-navbar-search-show")
                        .addClass("g-navbar-search-hiding");
                }, 150);

                setTimeout(function() {
                    $("body")
                        .removeClass("g-navbar-search-hiding")
                        .addClass("g-navbar-search-hidden");
                }, 300);

                setTimeout(function() {
                    $("body").removeClass("g-navbar-search-hidden");
                }, 500);
                break;
        }
    });

    // Add sidenav modifier classes on mouse events

    $(".sidenav").on("mouseenter", function() {
        if (!$("body").hasClass("g-sidenav-pinned")) {
            $("body")
                .removeClass("g-sidenav-hide")
                .removeClass("g-sidenav-hidden")
                .addClass("g-sidenav-show");
        }
    });

    $(".sidenav").on("mouseleave", function() {
        if (!$("body").hasClass("g-sidenav-pinned")) {
            $("body")
                .removeClass("g-sidenav-show")
                .addClass("g-sidenav-hide");

            setTimeout(function() {
                $("body")
                    .removeClass("g-sidenav-hide")
                    .addClass("g-sidenav-hidden");
            }, 300);
        }
    });


    // Collapsed Nav
    $(document).ready(function() {
        $("#menu-toggle").click(function(e) {
            e.preventDefault();
            $(".sidenav.fixed-left + .main-content").toggleClass("toggled");
            $(".navbar-nav .nav-item a span.nav-link-text, .navbar-nav .nav-item a span.dropdown-toggle").toggleClass('d-none');
            $(".g-sidenav-pinned .sidenav").toggleClass('collapsedNav');
        });
    });


    // Make the body full screen size if it has not enough content inside
    $(window).on("load resize", function() {
        if ($("body").height() < 800) {
            $("body").css("min-height", "100vh");
            $("#footer-main").addClass("footer-auto-bottom");
        }
    });

    $(document).ready(function() {
        $("body").tooltip({
            selector: '[data-toggle=tooltip]'
        });
    });
  }
};
</script>
